import React from 'react';
import styled, { keyframes } from 'styled-components';

const spin = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

const LoaderContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: ${props => props.fullScreen ? '100vh' : 'auto'};
`;

const SpinnerWrapper = styled.div`
  width: ${props => props.size}px;
  height: ${props => props.size}px;
  position: relative;
`;

const Spinner = styled.div`
  box-sizing: border-box;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: ${props => props.thickness}px solid #e0e0e0;
  border-top-color: #6c5ce7;
  border-radius: 50%;
  animation: ${spin} 0.8s linear infinite;
`;

const Loader = ({ size = 40, thickness = 3, fullScreen = false }) => {
    return (
        <LoaderContainer fullScreen={fullScreen}>
            <SpinnerWrapper size={size}>
                <Spinner thickness={thickness} />
            </SpinnerWrapper>
        </LoaderContainer>
    );
};

export default Loader;